import { isIos, isWeb } from './deviceUtils';

type RedirectType = 'credit-card' | 'mobile-pay' | 'adyen-redirect';

export const isMobilePayCallback = (url: string) =>
  url.includes('MOBILEPAY') && url.includes('userId');

// Web-only full-page navigation.
export const redirectExternal = (url: string) => {
  globalThis.location.href = url;
};

export const getRedirectUrl = (type: RedirectType): string => {
  if (isWeb) {
    if (type === 'mobile-pay') {
      return `${globalThis.location.origin}/account/my-payment-methods`;
    }
    if (type === 'adyen-redirect') {
      return `${globalThis.location.origin}/adyen-redirect`;
    }
    return `${globalThis.location.origin}/${type}-redirect`;
  }
  if (type === 'mobile-pay') {
    return 'com.aimoone://';
  }
  if (type === 'adyen-redirect') {
    return 'com.aimoone://adyen-redirect';
  }
  return isIos ? 'com.aimoone' : 'com.aimoone.auth:///';
};

export const getParameterByName = (name: string, url: string) => {
  if (!url) {
    return '';
  }
  name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) {
    return '';
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getDomain = (url: string) => {
  if (!url) {
    return '';
  }
  // eslint-disable-next-line no-control-regex
  const regex = new RegExp('^(?:https?://)?(?:[^@/\n]+@)?(?:www.)?([^:/?\n]+)');
  const results = regex.exec(url);
  if (!results) {
    return '';
  }
  return results[1];
};

export const defineNetsUrlType = (urlString: string) => {
  if (!urlString?.includes(getRedirectUrl('credit-card'))) {
    return false;
  }
  if (getParameterByName('status', urlString) === 'cancelled') {
    return 'cancel';
  }
  if (getParameterByName('status', urlString) === 'ok') {
    return 'success';
  }
  if (getParameterByName('status', urlString) === 'error') {
    return 'failure';
  }
  return false;
};

export const getNetsCardId = (urlString: string) => {
  return getParameterByName('cardId', urlString);
};
